import { createContext, useContext, useEffect, type Dispatch, type SetStateAction } from 'react'

export const PageTitleSetterContext = createContext<Dispatch<SetStateAction<string | null>> | null>(null)
export const PageTitleValueContext = createContext<string | null>(null)

export function usePageTitleValue(): string | null {
  return useContext(PageTitleValueContext)
}

/** Overrides the route title while the page is mounted; the shell adds the brand suffix. */
export function usePageTitle(title: string | null | undefined): void {
  const setPageTitle = useContext(PageTitleSetterContext)
  const normalized = title?.trim() || null

  useEffect(() => {
    if (setPageTitle === null) {
      if (normalized === null) return
      const previous = document.title
      document.title = normalized
      return () => {
        document.title = previous
      }
    }

    setPageTitle(normalized)
    return () => {
      setPageTitle((current) => (current === normalized ? null : current))
    }
  }, [normalized, setPageTitle])
}
